import router from './router'
import store from './store'
import { getToken } from '@/store/local/auth'
import { Message } from 'element-ui'
import { shouldPrepareInterviewStateForPath } from '@/constants/interviewRoutes'

const whiteList = [
  '/', '/qzpp', '/store/entry',
  '/store/dashboard/password', '/store/dashboard/phone', '/store/dashboard/QRCode'
] // no redirect whitelist

router.beforeEach(async (to, from, next) => {
  if (shouldPrepareInterviewStateForPath(to.path)) {
    try {
      await store.dispatch('interviewState/prepareInterviewRouteEntry', {
        toPath: to.path
      })
    } catch (e) {
      console.warn('[interviewState/prepareInterviewRouteEntry]', e)
    }
  }

  // determine whether the user has logged in
  const hasToken = getToken()
  if (hasToken) {
    if (to.path.startsWith('/store/entry')) {
      // if is logged in, redirect to the home page
      next({ path: '/store/dashboard' })
    } else {
      next()
    }
  } else {
    /* has no token */
    // 带 token 的面试链接入口页：允许直接进入「微笑启动面试」，不要求登录
    const isLinkEntryProfile = to.path.includes('dashboard/profile') && to.query && to.query.token
    // 面试进行页（链接流程进入）：不要求登录 token
    const isInterviewTokenRoute = to.meta?.interviewEntryMode === 'token' || to.path.includes('interview_ing_by_b')
    const isAnonymousRoute = to.meta?.allowAnonymous === true
    if (whiteList.indexOf(to.path) != -1 || isLinkEntryProfile || isInterviewTokenRoute || isAnonymousRoute) {
      next()
    } else {
      Message({
        message: '尚未登录',
        type: 'error',
        duration: 5 * 1000
      })
      next(`/store/entry?redirect=${to.path}`)
    }
  }
})

// router.afterEach(() => {
// })
